import { tapsForwardConfig } from '@/lib/analytics/kpis/instagram/stories/tapsForward';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const tapsForwardMVConfig = {
    ...tapsForwardConfig,
    id: 'taps_forward',
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
